import {LocalizationStrings} from "./i18n-model";

export const LOCALIZATIONS = new Map<string, LocalizationStrings>();

export function populateLocalizations(localizations: Map<string, LocalizationStrings>) {
  localizations.forEach((strings, language) => LOCALIZATIONS.set(language, strings));
}
